import React, { useMemo } from 'react';
import { DH } from '../../../utils/dataHooks';
import { type Locale } from '../../../types/Locale';
import { type Shape } from '../../../types/Styles';
import { st, classes } from './styles.st.css';

interface ApplePayProps {
  height: number;
  locale: Locale;
  color: 'black' | 'white';
  shape: Shape;
  onClick(): void;
}

export const ApplePayView = (props: ApplePayProps) => {
  const { locale, color, shape, height, onClick } = props;

  const styles = useMemo(
    () => ({
      height: `${height}px`,
    }),
    [height],
  );

  return (
    <section data-hook="apple-pay-view">
      <button
        lang={locale}
        data-hook={DH.ApplePay.Button}
        style={styles}
        className={st(classes.root, classes[color], classes[shape])}
        onClick={onClick}
      />
    </section>
  );
};
